import React from 'react';
import { ProgressSpinner } from 'primereact/components/progressspinner/ProgressSpinner';

export default () => (
    <div className="spinner-container">
        <ProgressSpinner />
    </div>
);
